const SAVED_ONLINE = 'SAVED_ONLINE';

const OFFLINE_ONLY = 'OFFLINE_ONLY';

const UPLOAD_FAILED = 'UPLOAD_FAILED';

const UPDATING = 'UPDATING';

const MULTIPLE_GROUPS = 'MULTIPLE_GROUPS';

const IN_PROGRESS = 'IN_PROGRESS';

const ERROR = 'ERROR';

const SUCCESS = 'SUCCESS';

export {
    SAVED_ONLINE,
    OFFLINE_ONLY,
    UPLOAD_FAILED,
    UPDATING,
    MULTIPLE_GROUPS,
    IN_PROGRESS,
    ERROR,
    SUCCESS
};
